import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Credential } from '../models/credential.model';

@Component({
    selector: 'app-confirm-delete',
    imports: [],
    templateUrl: './confirm-delete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './confirm-delete.component.scss'
})

export class ConfirmDeleteComponent {

	@Input() credential!: Credential;

	constructor(
		public modal: NgbActiveModal
	){}

}
